import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const editTemplateStyle: StyleRulesCallback = () => ({
  root: {
    textAlign: 'center',
    width: '60%',
    marginTop: '40px',
    marginLeft: '22%',
    maxHeight: '90%',
    overflow: 'auto',
  },
  noSections: {
    textAlign: 'left',
    paddingLeft: '25px',
  },
  buttonWrapper: {
    textAlign: 'right',
    marginRight: '20px',
  },
  addSectionButton: {
    marginTop: '25px',
    marginBottom: '25px',
    paddingRight: '25px',
  },
  sortButton: {
    marginTop: '25px',
    marginBottom: '25px',
    paddingRight: '25px',
    marginLeft: '5px',
  },
  addIcon: {
    marginRight: '10px',
    color: 'white',
  },
  warning: {
    paddingTop: '20px',
  },
});

export default editTemplateStyle;
